/* eslint-disable react/no-children-prop */
import React from "react";
import { Wrapper, Title, Description } from "./styled";

const Header = () => {
  return (
    <Wrapper>
      <Title children="Registrarse" />
      <Description children="Ingresá tus datos para solicitar tu registro" />
    </Wrapper>
  );
};

export default Header;
